export function defaultDashboardRange() {
  const to = new Date();
  const from = new Date();
  from.setMonth(from.getMonth() - 5);
  from.setDate(1);
  const fmt = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  };
  return { from_date: fmt(from), to_date: fmt(to) };
}

export const formatMoneyPen = (value) =>
  `S/ ${Number(value || 0).toLocaleString('es-PE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export function formatDateDisplay(iso) {
  if (!iso) return '—';
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split('-');
  if (!d) return s;
  return `${d}/${m}/${y}`;
}

export function formatPos(pos) {
  if (!pos) return '—';
  return `${pos.code ? `${pos.code} — ` : ''}${pos.name}`;
}

export function formatQty(value) {
  if (value == null || !Number.isFinite(Number(value))) return '—';
  return Number(value).toLocaleString('es-PE', { maximumFractionDigits: 3 });
}

const SALE_ROUTE_LABELS = {
  service_order: 'OSV',
  cash_sale: 'Efectivo',
};

export function columnRouteLabel(route) {
  return SALE_ROUTE_LABELS[route] || route || '—';
}
